(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ct-pdp-academy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ct-academy')) {
  customElements.define('ct-academy', class extends HTMLElement {
    connectedCallback() {
      if (this.academyReady) return;
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('[data-academy-open]');
      if (!dialog || !trigger) return;
      this.academyReady = true;
      trigger.addEventListener('click', () => {
        dialog.showModal();
        document.documentElement.classList.add('ct-academy-modal-open');
      });
      this.querySelector('[data-academy-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('ct-academy-modal-open');
        trigger.focus({ preventScroll: true });
      });
    }
    disconnectedCallback() {
      if (this.querySelector('dialog')?.open) document.documentElement.classList.remove('ct-academy-modal-open');
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
